// extracted by mini-css-extract-plugin
export default {"hidden":"RegisterForm_hidden__CNHTm"};